<template>
  <v-container fluid>
    <v-card>
      <v-toolbar dense flat color="secondary">
        <v-toolbar-title>Purchases Import</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-btn color="primary" @click.native="importDialog = true" text
              ><v-icon>mdi-plus</v-icon>New Purchase Import</v-btn
            >
          </v-col>
        </v-row>

        <v-divider></v-divider>

        <v-col cols="12" class="subtitle-2 text--primary">
          <v-text-field
            name="Search"
            v-model="search"
            label="Search"
            dense
          ></v-text-field>
          <!-- start of table -->
          <v-data-table
            :mobile-breakpoint="0"
            :items-per-page="1000"
            :headers="headers"
            :items="pendingSales"
            :search="search"
          >
            <!-- action template -->
            <template v-slot:item.action="{ item }">
              <v-btn
                :loading="loader"
                @click="processExcel(item.id)"
                color="accent"
                text
                ><v-icon left>mdi-progress-clock</v-icon> Process Excel</v-btn
              >
            </template>
            <!-- end -->
          </v-data-table>
          <!-- end -->
        </v-col>

        <!--  Products summary dialog -->
        <v-dialog v-model="importDialog" max-width="850px">
          <v-card>
            <v-toolbar dense color="accent" dark>
              <v-toolbar-title>Upload Purchases Excel</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="importDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="6">
                    <v-autocomplete
                      autocomplete="off"
                      dense
                      outlined
                      v-model="CardCode"
                      :items="suppliers"
                      label="Supplier"
                      item-text="Name"
                      item-value="id"
                    >
                    </v-autocomplete>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6">
                    <v-text-field
                      v-model="title"
                      label="Title"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6">
                    <DatePicker
                      @date="setDate"
                      :myDate="date"
                      :title="`Date`"
                    ></DatePicker>
                  </v-col>

                  <v-col cols="6">
                    <v-file-input
                      name="productExcelFile"
                      v-model="excelFile"
                      label="Browse Excel Sheet"
                      outlined
                      dense
                    ></v-file-input>
                  </v-col>

                  <v-col cols="12">
                    <v-btn
                      color="primary"
                      @click="uploadExcel"
                      :loading="loader"
                    >
                      <v-icon left>mdi-upload</v-icon>Upload Purchases Excel
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of products summary modal-->

        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      search: null,
      record: {},
      loader: false,
      CardCode: null,
      suppliers: [],
      importDialog: false,
      pageItems: 2000,
      date: new Date().toISOString().substr(0, 10),
      menu1: false,
      menu2: false,
      menu3: false,
      summaryData: [],
      excelFile: null,
      title: null,
      headers: [
        { text: "Sales Title", value: "Name" },
        { text: "Date", value: "DocDate" },
        { text: "Comment", value: "Comment" },
        { text: "Status", value: "Status" },
        { text: "Action", value: "action" },
      ],
      pendingSales: [],
      totalSales: null,
      returnsData: [],
      TotalReturns: null,
    };
  },
  computed: {
    totalSalesValue() {
      let total = 0;
      if (this.totalSales) {
        total = this.totalSales.toLocaleString();
      }
      return total;
    },
    storeName() {
      return localStorage.getItem("storeName");
    },
  },
  methods: {
    setDate(date) {
      this.date = date;
    },
    processExcel(id) {
      const url = `/import-documents/${id}`;
      const self = this;
      this.loader = true;
      const data = {};
      this.$store
        .dispatch("put", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            self.getRecords();
          } else {
            self.loader = false;
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    uploadExcel() {
      if (this.date == null) {
        this.$refs.snackbar.show("Please fill all fields", "red");
      } else {

      var storeId = localStorage.getItem("store_id");
      var subscriberId = localStorage.getItem("subscriber_id");
        const data = new FormData();
        data.append("documentData", this.excelFile);
        data.append("DocDate", this.date);
        data.append("store_id", parseInt(storeId));
        data.append("subscriber_id", parseInt(subscriberId));
        // data.append("Name", this.title);
        // data.append("CardCode", this.CardCode);
        // data.append("ObjType", 12);
        // send request

        this.loader = true;
        const url = "/import-stock";
        const self = this;
        this.$store
          .dispatch("post", { url, data })
          .then((res) => {
            if (res.ResultCode == 1200) {
              self.$refs.snackbar.show(
                "Products imported successfully",
                "green"
              );
              self.loader = false;
              self.importDialog = false;
              self.excelFile = null;
              location.reload();
             // self.getRecords();
            } else {
              self.loader = false;
              self.$refs.snackbar.show(res.ResultDesc, "red");
            }
          })
          .catch((err) => {
            self.loader = false;
            this.$refs.snackbar.show(err, "red");
          });
        // end
      }
    },
    getRecords() {
      const self = this;
      this.$store.commit("loader", true);
      const url = `/import-documents`;
      this.$store
        .dispatch("get", url)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.pendingSales = res.ResponseData;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getSuppliers() {
      const self = this;
      this.$store
        .dispatch("get", `/suppliers`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.suppliers = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
  created() {
   // this.getRecords();
    this.getSuppliers();
  },
};
</script>

<style lang="scss" scoped>
</style>